import { useEffect, type ReactNode } from 'react'
import { Link } from 'react-router-dom'
import '../styles/legal.css'

type LegalPageLayoutProps = {
  title: string
  children: ReactNode
}

export function LegalPageLayout({ title, children }: LegalPageLayoutProps) {
  useEffect(() => {
    document.title = `${title} — gymAhead`
  }, [title])

  return (
    <div className="legal-page">
      <header className="sticky top-0 z-50 bg-surface/80 backdrop-blur-xl border-b border-outline-variant/40">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-4">
          <Link
            to="/"
            className="text-xl font-headline font-bold tracking-wide text-on-surface hover:text-primary transition-colors"
          >
            gymAhead
          </Link>
          <Link
            to="/"
            className="text-sm text-on-surface-variant hover:text-secondary transition-colors"
          >
            ← Home
          </Link>
        </div>
      </header>

      <main className="legal-container">
        <Link to="/" className="legal-back-link">
          ← Back to gymAhead
        </Link>
        {children}
        <LegalFooter />
      </main>
    </div>
  )
}

function LegalFooter() {
  return (
    <div className="legal-footer">
      <p className="mb-2">gymAhead is operated by Kwame Ofori, Germany.</p>
      <p>
        <Link to="/">Home</Link>
        {' · '}
        <Link to="/support">Support</Link>
        {' · '}
        <Link to="/privacy">Privacy</Link>
        {' · '}
        <Link to="/impressum">Impressum</Link>
        {' · '}
        <a href="mailto:contact@beahead.ai">Contact</a>
      </p>
    </div>
  )
}
